import {injectable} from "inversify";
import {Listener} from "@/store/listener";
import {Player} from "@/store/player/types";
import {ArtifactUpdatesPanel} from "@/scenes.ui/artifact-updates-panel";
import SceneUtils from "@/utils/scene-utils";
import ListenerManager from "@/managers/listener-manager";
import {NotificationPanel} from "@/scenes.ui/notification-panel";
import {Keys} from "@/constants/key";
import SoundUtils from "@/utils/sound-utils";
import ArtifactStore from "@/store/artifact";
import PlayerStore from "@/store/player";

@injectable()
export class ArtifactNotificationService implements Listener {

    private timerId: number | undefined = undefined;

    private static getRefreshInterval(player: Player) {
        if (!player || !player.stair || player.stair < 10) {
            return 20000;
        } else if (player.stair < 30) {
            return 60000;
        } else {
            return 300000;
        }
    }

    public setupScheduledTask() {

        if (!this.timerId) {

            let player: Player = PlayerStore.getPlayer()!;
            if (player.notifications && player.notifications.length > 0) {
                SceneUtils.getCurrentScene().time.delayedCall(500, () => {
                    let openingSound = SoundUtils.addSound(SceneUtils.getCurrentScene(), Keys.SOUND_AWARD);
                    let clickSound = SoundUtils.addSound(SceneUtils.getCurrentScene(), Keys.SOUND_BUTTON_CLICK);
                    let uap: ArtifactUpdatesPanel = new ArtifactUpdatesPanel(SceneUtils.getCurrentScene(), SceneUtils.getCanvas(),
                        player.notifications, openingSound, clickSound);
                    ArtifactStore.clearNotifications().then(() => {
                        uap.open();
                    });
                });
            }

            this.timerId = setInterval(() => {
                this.job();
            }, ArtifactNotificationService.getRefreshInterval(player));
            ListenerManager.addPlayerListener(this);
        }
    }

    onChange(): void {
        ArtifactNotificationService.showNotification();
    }

    private job() {
        ArtifactStore.isTimeToActualize().then((isTime: boolean) => {
            if (isTime) {
                ArtifactStore.actualizeArtifacts();
            }
        });
    }

    private static showNotification() {
        let player: Player = PlayerStore.getPlayer()!;
        if (player.notifications && player.notifications.length > 0) {
            let notification = player.notifications[0];
            let uap: NotificationPanel = new NotificationPanel(SceneUtils.getCurrentScene(), SceneUtils.getCanvas(), notification);
            ArtifactStore.deleteNotification(notification.id).then(() => {
                uap.open();
            });
        }
    }

}
